import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import {
    StyledFilterContent,
    StyledQuickFilterBorder,
} from 'src/pages/orders/components/quickFilters/QuickFilters.styled';

export const TabGridContianer = styled.ul`
    margin: 0;
    padding: 0;
    width: 100%;
    display: grid;
    grid-auto-rows: 3em;
    grid-template-columns: repeat(7, 1fr) 1.2fr;
    gap: 0px;
    box-sizing: border-box;

    ${media.mediumDevice`
    grid-template-columns: repeat(7,1fr) 1.2fr;
`}
    ${media.smalDevice`
    grid-template-columns: repeat(7,1fr) 1.2fr;
    grid-auto-rows: 3em;
`}
${media.mobileDevice`
    grid-template-columns: repeat(3,1.2fr)};
    gap: 0px;
    grid-auto-rows: ${({ isLandscape }) => (isLandscape ? '2.5em' : '2.5em')};
`}
`;

export const StyledTabContentContianer = styled.li`
    display: flex;
    flex-direction: column;
    width: 100%;
    box-sizing: border-box;
    background-color: ${({ isSelected }) =>
        isSelected ? '#FFFFFF' : '#EBEDED'};
    border: 0.5px solid #d7dbdb;
    opacity: 1;
    height: 100%;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: ${(props) => (props.cursor ? props.cursor : 'none')};
    ${media.mobileDevice`
    height: 100%;
    `}
`;

export const TabContent = styled(StyledFilterContent)`
    height: 95%;
    width: max-content;
    justify-content: center;
    align-items: center;
    padding: 0 10px;

    ${media.mediumDevice`
        padding: 0 0.3rem;
    `}
    ${media.smalDevice`
        padding: 0 0.2rem;
    `}
    ${media.mobileDevice`
        padding: 0 0.4rem;
        width: 54%;
    `}
`;

export const TabSelectedBorder = styled(StyledQuickFilterBorder)``;

export const TabContentFont = styled.p`
    display: block;
    margin: 0;
    padding: 10px;
    padding-top: 11px;
    text-align: left;
    letter-spacing: 0px;
    color: ${({ isSelected }) => (isSelected ? '#1010EB' : '#555555')};
    font-size: 13px;
    font-family: 'AvenirNextWorld Demi';
    line-height: 16px;
    opacity: 1;
    white-space: ${({ isJapanUser }) => (isJapanUser ? 'nowrap' : 'normal')};
    ${media.mobileDevice`
        text-align: center;
        color: ${({ isSelected }) => (isSelected ? '#1010EB' : '#202124')};
    `}
`;
